<template>
  <div class="box-field" :class="{ error: error }">
    <input
      type="text"
      class="form-control form-control_name"
      :placeholder="allowed ? $t('forms.your_name') : $t('forms.name_unavailable')"
      :maxlength="maxlength"
      :disabled="disabled || !allowed"
      :error="error"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
    <div class="box-field__count" v-if="allowed">
      {{$t('forms.symbol_limit')}}: {{ value.length }}/{{ maxlength }}
    </div>
  </div>
</template>
<script>
export default {
  name: "NameInput",
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowed: {
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
      default: 30
    },
    error: {
      type: Boolean,
      default: false
    }
  }
};
</script>
